<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import PreviewHeader from "../PreviewHeader.vue";
import {getCurrentInstance} from "vue";
import {RouterLink} from "vue-router";

export default {
  name: "Example",
  props: ['srcbild', 'option', 'type', 'producttype'],
  emits: ['result'],
  inject: ['t','localeState'],
  components: {
    RouterLink,
    PreviewHeader,
    VueCropper,
  },
  data() {
    return {
      imgSrc: this.srcbild,
      instance: getCurrentInstance(),
      cropImg: this.srcbild,
      tabActive: '',
      editor: false,
      canvas: false,
      newCropDaten: false,
      startUrl: false,
      ctx: false,
      imgSize: false,
      watchRahmen: false,
      isCropped: false,
      rationNew: false,
      rationRotate: false,
      data: null,
    };
  },
  methods: {
    cropImgHeight : function () {

      if (this.$route.matched[0]?.props.default.wand) {
        return;
      }

      if(this.instance.appContext.config.globalProperties.$orientation === 'portrait'){
        switch (this.option["Größe"]) {
          case '20x30cm':
            return "79%"
          case '30x45cm':
            return "85%"
          case '40x60cm':
            return "88%"
          case '50x75cm':
            return "90%"
          case '60x90cm':
            return "92%"
          case '80x120cm':
            return "93.6%"
          case '80x150cm':
            return "95%"
        }
      }
      if(this.instance.appContext.config.globalProperties.$orientation === 'landscape') {
        return "auto";
      }

      if (this.rationCropper() > 1) {
        return "auto";
      } else if (this.rationCropper() === 1) {
        switch (this.option["Größe"]) {
          case '25x25cm':
            return "75.5%"
          case '30x30cm':
            return "79%"
          case '40x40cm':
            return "83%"
          case '50x50cm':
            return "86%"
          case '60x60cm':
            return "88%"
          case '80x80cm':
            return "91%"
        }
      } else {
        switch (this.option["Größe"]) {
          case '20x30cm':
            return "79%"
          case '30x45cm':
            return "85%"
          case '40x60cm':
            return "88%"
          case '50x75cm':
            return "90%"
          case '60x90cm':
            return "92%"
          case '80x120cm':
            return "93.6%"
          case '80x150cm':
            return "95%"
        }
      }
    },
    cropImgWidth: function () {

      if (this.$route.matched[0]?.props.default.wand) {
        return;
      }

      if(this.instance.appContext.config.globalProperties.$orientation === 'landscape') {
        switch (this.option["Größe"]) {
          case '20x30cm':
            return "79%"
          case '30x45cm':
            return "85%"
          case '40x60cm':
            return "88.5%"
          case '50x75cm':
            return "90.5%"
          case '60x90cm':
            return "92%"
          case '80x120cm':
            return "93.6%"
          case '80x150cm':
            return "95%"
        }
      }
      if(this.instance.appContext.config.globalProperties.$orientation === 'portrait'){
        return "auto"
      }

      if (this.rationCropper() > 1 ) {
        switch (this.option["Größe"]) {
          case '20x30cm':
            return "79%"
          case '30x45cm':
            return "85%"
          case '40x60cm':
            return "88.5%"
          case '50x75cm':
            return "90.5%"
          case '60x90cm':
            return "92%"
          case '80x120cm':
            return "93.6%"
          case '80x150cm':
            return "95%"
        }
      } else if (this.rationCropper() === 1) {
        return "auto"
      } else {
        return "auto"
      }
    },
    reloadPage: function () {
      window.location.href = this.startUrl;
    },
    handleButtonClick: function () {
      this.editor = true;
      this.rationCropper();
    },
    handleEditorHide: function () {
      this.editor = false;
    },
    getImageSizeToRoom: function (option) {

      this.imgSize = document.querySelector('.preview-area img.croppedImage');
      if(!this.imgSize) {
        return;
      }
      if (this.$route.name === "produktansicht") {
        this.imgSize.removeAttribute('width');
        this.imgSize.removeAttribute('height');
        return;
      }
      const roomSize = document.querySelector('img.bottom');
      const ration = option['Größe'].split('x');



      let imgSizeWidth = ((roomSize.width - 180) / 200) * Number(ration[0]);
      let imgSizeHeight = ((roomSize.width - 180) / 200) * Number(ration[1].slice(0, -2));

      if(window.innerWidth < 760) {
        if (this.imgSize.width > this.imgSize.height) {
          imgSizeHeight = ((roomSize.width - 180) / 200) * Number(ration[0]);
          imgSizeWidth = ((roomSize.width - 180) / 200) * Number(ration[1].slice(0, -2));
        } else {
          imgSizeWidth = ((roomSize.width - 180) / 200) * Number(ration[0]);
          imgSizeHeight= ((roomSize.width - 180) / 200) * Number(ration[1].slice(0, -2));
        }

        if(!this.dp) {
          imgSizeWidth *= 2;
          imgSizeHeight *= 2;
        }

      } else {
        if (this.imgSize.width > this.imgSize.height) {
          imgSizeHeight = ((roomSize.width - 180) / 200) * Number(ration[0]);
          imgSizeWidth = ((roomSize.width - 180) / 200) * Number(ration[1].slice(0, -2));
        }
      }

      this.imgSize.width = imgSizeWidth;
      this.imgSize.height = imgSizeHeight;
    },
    cropImage() {
      this.isCropped = true;
      this.cropImg = this.$refs.cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL("image/jpeg");
      this.instance.appContext.config.globalProperties.$cropimage = this.$refs.cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL("image/jpeg");
      const cropper = this.$refs.cropper;
      this.newCropDaten = cropper.getCropBoxData();
      this.handleEditorHide();
      this.rahmen();
      setTimeout(() => {
        this.imgSize = document.querySelector('.preview-area img.croppedImage');
      }, "300");

      // this.rahmen();
    },
    stretch() {
      this.$refs.cropper.scaleX(this.$refs.cropper.getCropBoxData().width/this.$refs.cropper.cropper.canvasData.width);
      this.$refs.cropper.scaleY(this.$refs.cropper.getCropBoxData().height/this.$refs.cropper.cropper.canvasData.height);
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    rotate() {
      console.log(this.ration);
      if (typeof this.ration !== "undefined") {
        this.rationRotate = this.ration;
        this.rationNew = false;
      }
      if (!this.rationNew) {
        this.rationNew = this.rationRotate.split("/");
      } else {
        this.rationNew = Object.fromEntries(
            Object.entries(this.rationNew).map(([key, value]) => [key === '0' ? '1' : '0', value])
        );
      }

      this.instance.appContext.config.globalProperties.$orientation = false;
      this.$refs.cropper.setAspectRatio(this.rationNew[1] / this.rationNew[0]);
      this.rahmen();
    },
    handleFileChange(event) {
      this.srcbild = URL.createObjectURL(event.target.files[0]);
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rahmen: function () {

      if (!this.option["Größe"]) {
        return '30x30cm';
      }

      const sizes = this.option["Größe"].split("x");
      this.imgSize = document.querySelector('.preview-area img.croppedImage');
      let rahmenSize;
      if(this.imgSize?.naturalWidth) {
        if (sizes.length > 3) {
          rahmenSize = '5pcs-canvas_' + sizes[1] + 'x' + sizes[2].slice(0, -2);
        } else if (sizes.length === 3) {
          rahmenSize = sizes[0] + 'pcs-canvas_' + sizes[1] + 'x' + sizes[2].slice(0, -2);
        } else {

          if(this.instance.appContext.config.globalProperties.$orientation) {
            if(this.instance.appContext.config.globalProperties.$orientation === 'landscape') {
              rahmenSize = 'canvas_' + sizes[1].slice(0, -2) + 'x' + sizes[0]
            } else {
              let produktbild = document.querySelector(".produktbild");

              if(produktbild && produktbild.classList.contains('maxHeight') == false) {
                produktbild.classList.add('maxHeight')
              }
              rahmenSize = 'canvas_' + sizes[0] + 'x' + sizes[1].slice(0, -2)
            }
          } else {
            if (this.imgSize.naturalWidth > this.imgSize.naturalHeight) {
              rahmenSize = 'canvas_' + sizes[1].slice(0, -2) + 'x' + sizes[0]
            } else {
              rahmenSize = 'canvas_' + sizes[0] + 'x' + sizes[1].slice(0, -2)
            }
          }


        }
      }

      if(rahmenSize == undefined) {
        setTimeout(() => {
          this.rahmen();
        }, "500");

      }
      this.watchRahmen = rahmenSize + 'cm';
      return rahmenSize + 'cm';
    },
    getCutImg() {
      const maxWidth = 150; // Maximal erlaubte Breite
      const maxHeight = 1000; // Maximal erlaubte Höhe

      const image = new Image();
      let instance = getCurrentInstance();
      image.src = instance.appContext.config.globalProperties.$cropimage.value;

      if (instance.appContext.config.globalProperties.$cropimage.value === undefined) {
        image.src = this.srcbild;
      }

      const _t =this;
      image.onload = function () {
        if (image.width > maxWidth) {
          const scaleFactor = maxWidth / image.width;
          image.width = maxWidth;
          image.height *= scaleFactor;
        }

        if (image.height > maxHeight) {
          const scaleFactor = maxHeight / image.height;
          image.height = maxHeight;
          image.width *= scaleFactor;
        }

        if(instance.appContext.config.globalProperties.$producttype.trim() == 'Eigenes Bild  XXL / 3') {
          _t.drawStep3(instance.appContext.config.globalProperties.$orientation.value);
        } else if(instance.appContext.config.globalProperties.$producttype.trim() == 'Eigenes Bild XXL / 5') {
          _t.drawStep5(instance.appContext.config.globalProperties.$orientation.value, _t.getDimensionsDataFromTitle('2x20x35-2x20x45-1x20x55'));
        }
      };
    },
    getDimensionsDataFromTitle(title) {
      // 2x20x35-2x20x45-1x20x55
      if (title.match(/2x(\d+)x(\d+)-2x(\d+)x(\d+)\D.*(\d\d)/)) {
        const split = 5;
        const single = parseInt(RegExp.$1);
        const step1 = parseInt(RegExp.$2);
        const step2 = parseInt(RegExp.$4);
        const short = parseInt(RegExp.$5);
        const long = split * single;
        const steps = [step1, step2, short, step2, step1];

        return {
          split,
          steps,
          short,
          long,
          format: 'split5',
        };
      }

      // Hard-coded dimensions for US split5
      if (title === '39" x 22" / 100x55cm') {
        const split = 5;
        const single = 20;
        const step1 = 35;
        const step2 = 45;
        const short = 55;
        const long = split * single;
        const steps = [step1, step2, short, step2, step1];

        return {
          split,
          steps,
          short,
          long,
          format: 'split5',
        };
      }

      // Hard-coded dimensions for US small split3
      if (title === '32" x 16" / 81x40cm') {
        const split = 3;
        const single = 27;
        const short = 40;
        const long = split * single;
        const steps = [single, single, single];

        return {
          split,
          steps,
          short,
          long,
          format: 'split3',
        };
      }

      // Hard-coded dimensions for US large split3
      if (title === '44" x 22" / 111x55cm') {
        const split = 3;
        const single = 37;
        const short = 55;
        const long = split * single;
        const steps = [single, single, single];

        return {
          split,
          steps,
          short,
          long,
          format: 'split3',
        };
      }

      if (title.match(/(\d+)x(\d+)x(\d+)\D*/)) {
        const split = 3;
        const single = parseInt(RegExp.$2);
        const short = parseInt(RegExp.$3);
        const long = split * single;
        const steps = [single, single, single];

        return {
          split,
          steps,
          short,
          long,
          format: 'split3',
        };
      }

      if (title.match(/(\d+)x(\d+)\D*/)) {
        let short = parseInt(RegExp.$1);
        let long = parseInt(RegExp.$2);

        if (short > long) {
          const tmp = short;
          short = long;
          long = tmp;
        }

        return {
          short,
          long,
          format: (short === long) ? 'square' : 'rect',
        };
      }

      return false;
    },
    drawStep5(orientation, dimensions) {


      const cut1 = (dimensions.short - dimensions.steps[0]) / dimensions.short;
      const cut2 = (dimensions.short - dimensions.steps[1]) / dimensions.short;

      if (orientation === 'landscape') {

        const split = 800 / 5;
        this.splitLineDownNew(split, );

        return;
      }

      if (orientation === 'portrait') {
        const split = h / 5;
        this.splitLineRight(w, split,ctx);
        this.splitLineRight(w, 2 * split,ctx);
        this.splitLineRight(w, 3 * split,ctx);
        this.splitLineRight(w, 4 * split,ctx);

        this.cutWidthOfHeightN(cut1, w, h, 0,ctx);
        this.cutWidthOfHeightN(cut2, w, h, 1,ctx);
        this.cutWidthOfHeightN(cut2, w, h, 3,ctx);
        this.cutWidthOfHeightN(cut1, w, h, 4,ctx);
      }
    },
    cutWidthOfHeightN(widthCut, w, h, i,ctx) {
      const rd = Math.round;
      ctx.fillRect(0, rd(h / 5 * i), rd(widthCut / 2 * w), rd(h / 5));
      ctx.fillRect(rd(w - widthCut / 2 * w), rd(h / 5 * i), w, rd(h / 5));
    },
    cutHeightOfWidthN(heightCut, w, h, i,ctx) {
      const rd = Math.round;
      ctx.fillRect(rd(w / 5 * i), 0, rd(w / 5) + 1, rd(heightCut / 2 * h));
      ctx.fillRect(rd(w / 5 * i), rd(h - heightCut / 2 * h), rd(w / 5) + 1, rd(heightCut / 2 * h));
    },

    drawStep3(orientation,ctx,canvas) {
      const w = canvas.width;
      const h = canvas.height;
      ctx = canvas.getContext('2d');
      ctx.fillStyle = '#c5c1bc';


      if (orientation === 'landscape') {
        splitLineDown(w / 3, h,ctx);
        splitLineDown(2 * w / 3, h,ctx);
        return;
      }

      if (orientation === 'portrait') {
        splitLineRight(w, h / 3,ctx);
        splitLineRight(w, 2 * h / 3,ctx);
      }
    },
    splitLineRight(x, y, width = 10,ctx) {
      ctx.fillRect(0, Math.round(y), x, width);
    },
    splitLineDown(x, y, ctx, width = 50) {
      const img = new Image();
      img.src = this.$refs.cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL();

      img.onload = function () {
        // ctx.drawImage(img, 0, 0, x, y, 0, 0, x,500);
        let test = img.height/300;
        // ctx.drawImage(img,0,0,100,img.height,0,0,img.width,img.height);
        ctx.drawImage(img, x, 0, 100, img.height, 100,0, x, img.height);
      }
      // ctx.fillRect(Math.round(x), 0, width, y);
    },
    splitLineDownNew(x,  newposition = 0,  add = 0) {
      const img = new Image();
      img.src = this.$refs.cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL();
      const maxWidth = 800; // Maximal erlaubte Breite
      const maxHeight = 800; // Maximal erlaubte Höhe

      img.onload = function () {
        // ctx.drawImage(img, 0, 0, x, y, 0, 0, x,500);
        if (img.width > maxWidth) {
          const scaleFactor = maxWidth / img.width;
          img.width = maxWidth;
          img.height *= scaleFactor;
        }

        if (img.height > maxHeight) {
          const scaleFactor = maxHeight / img.height;
          img.height = maxHeight;
          img.width *= scaleFactor;
        }

        let canvas = document.getElementById('canvas');
        let canvas2 = document.getElementById('canvas2');
        let canvas3 = document.getElementById('canvas3');
        let canvas4 = document.getElementById('canvas4');
        let canvas5 = document.getElementById('canvas5');
        const w = canvas.width;
        const h = canvas.height;

        canvas.width = 160;
        canvas.height = img.height;
        canvas2.width = 160;
        canvas2.height = img.height;
        canvas3.width = 160;
        canvas3.height = img.height;
        canvas4.width = 160;
        canvas4.height = img.height;
        canvas5.width = 160;
        canvas5.height = img.height;

        let ctx = canvas.getContext('2d');
        let ctx2 = canvas2.getContext('2d');
        let ctx3 = canvas3.getContext('2d');
        let ctx4 = canvas4.getContext('2d');
        let ctx5 = canvas5.getContext('2d');


        // ctx.drawImage(img,0,0,100,img.height,0,0,img.width,img.height);
        // ctx.drawImage(img, newposition, 0, x, img.height, add,0, x, img.height);
        ctx.drawImage(img, newposition, 0,img.width, img.height);
        ctx2.drawImage(img, -1*x, 0,img.width, img.height);
        ctx3.drawImage(img, -2*x, 0,img.width, img.height);
        ctx4.drawImage(img, -3*x, 0,img.width, img.height);
        ctx5.drawImage(img, -4*x, 0,img.width, img.height);
        // ctx.drawImage(img, x, 0, x, img.height, x+100,0, x, img.height);
        // ctx.drawImage(img, x*2, 0, x, img.height, (x+100)*2,0, x, img.height);
        // ctx.drawImage(img, x*3, 0, x, img.height, (x+100)*3,0, x, img.height);
        // ctx.drawImage(img, x*4, 0, x, img.height, (x+100)*4,0, x, img.height);
      }
      // ctx.fillRect(Math.round(x), 0, width, y);
    },
    automatischesZuschneiden() {
      // Greifen Sie auf die Cropper-Instanz zu
      const cropper = this.$refs.cropper;

      // Seitenverhältnis
      const ratio = this.rationCropper(); // Ändern Sie dies entsprechend Ihren Anforderungen

      if(!cropper) {
        return;
      }
      // Setzen Sie das Seitenverhältnis auf der Cropper-Instanz
      cropper.setAspectRatio(ratio);

      // Mittelpunkt des Cropper
      const centerX = cropper.getContainerData().width / 2;
      const centerY = cropper.getContainerData().height / 2;

      // Definieren Sie den gewünschten Ausschnitt mit dem Seitenverhältnis und zentrieren Sie ihn
      const cropBoxData = {
        left: centerX - (cropper.getCropBoxData().width / 2),
        top: centerY - (cropper.getCropBoxData().height / 2),
      };
      // Setzen Sie den Ausschnitt programmatisch
      cropper.setCropBoxData(cropBoxData);

      if(this.newCropDaten) {
        cropper.setCropBoxData(this.newCropDaten);
      }


      // Führen Sie das Zuschneiden durch
      this.cropImg = cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL("image/jpeg");
      this.imgSize = cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL("image/jpeg");
      this.instance.appContext.config.globalProperties.$cropimage = cropper.getCroppedCanvas({  maxWidth: 2000, maxHeight: 2000}).toDataURL("image/jpeg");
    },
    rationCropper: function () {


      this.imgSize = document.querySelector('.preview-area img.croppedImage');
      if(!this.imgSize) {
        return;
      }


      this.getImageSizeToRoom(this.option);

      if (!this.option["Größe"]) {
        return 1;
      }
      // this.imgSize = document.querySelector('.preview-area img.croppedImage')
      const sizes = this.option["Größe"].split("x");
      let ration;
      let instance = getCurrentInstance();

      if(instance &&  instance.appContext.config.globalProperties.$producttype === 'Quadratisch') {
        this.$refs.cropper.setAspectRatio(1);
        return 1;
      }

      if (this.imgSize.naturalWidth > this.imgSize.naturalHeight) {
        ration = sizes[1].slice(0, -2) / sizes[0]
      } else {
        ration = sizes[0] / sizes[1].slice(0, -2)
      }
      if(!this.$refs.cropper) {
        return;
      }

      this.$refs.cropper.setAspectRatio(ration);
      return ration;
    }
// upload() {
//   const canvas = this.$refs.cropper.getCroppedCanvas();
//   canvas.toBlob((blob) => {
//     // Schritt 2: Erstelle ein FormData-Objekt, um das Bild für die Übertragung vorzubereiten
//     const formData = new FormData();
//     formData.append('croppedImage', blob); // Stelle sicher, dass 'cropped-image.jpg' der gewünschte Dateiname ist
//
//     // Schritt 3: Sende das Bild an den Server (zum Beispiel mit Fetch)
//     fetch('https://querytag.de/projekte/picmondoo/uploaded/index.php', {
//       method: 'POST',
//       body: formData,
//     })
//         .then(response => {
//           // Handle die Antwort des Servers hier
//           console.log('Bild erfolgreich hochgeladen!', response);
//         })
//         .catch(error => {
//           // Handle etwaige Fehler hier
//           console.error('Fehler beim Hochladen des Bildes:', error);
//         });
//   });
// }
  },
  created() {
    this.startUrl =this.$route.fullPath;
    this.cropImg = this.srcbild;
    this.tabActive = this.$tabactive;
  }
  ,
  mounted() {
    if(this.instance.appContext.config.globalProperties.$cropimage) {
      this.cropImg = this.instance.appContext.config.globalProperties.$cropimage;
      this.cropImgHeight();
    } else {
      this.imgSize = document.querySelector('.preview-area img.croppedImage');
      setTimeout(() => {
        this.automatischesZuschneiden();
      }, "300");
    }



  },
  watch: {
    tabActive: function(tabActiveNew, tabActiveOld) {

      if(tabActiveNew.trim() !== 'Eigenes Bild  XXL / 3' && tabActiveNew.trim() !== 'Eigenes Bild XXL / 5') {
        this.automatischesZuschneiden();
      }
    },
    watchRahmen: function(rahmenNew, rahmenOld){
      if(rahmenNew == 'undefinedcm') {
        this.rahmen();
      }
      if(rahmenOld == 'undefinedcm' && rahmenNew !== 'undefinedcm') {
        let rahmenImg = document.querySelector('.rahmen');
      }

    },
    'option.Größe': function (instanceNew,instanceOld) {
      // if(this.isCropped) {
      //   return;
      // }
      this.automatischesZuschneiden();
    },
    imgSize: function (imgSizeNew, imgSizeOld) {
      this.rahmen();
    }
  },
  computed: {
    rahmenImgHeight : function () {
      if (this.$route.matched[0]?.props.default.wand) {
        return;
      }

      if (this.rationCropper() > 1) {
        return "100%";
      } else if (this.rationCropper() === 1) {
        return "100%";
      } else {
        return "100%";
      }
    },
    rahmenImgWidth : function () {
      if (this.$route.matched[0]?.props.default.wand) {
        return;
      }

      if (this.rationCropper() > 1) {
        return "auto";
      } else if (this.rationCropper() === 1) {
        return "auto";
      } else {
        return "auto";
      }

    },
    ration: function () {
      // if(this.instance.appContext.config.globalProperties.$producttype && this.instance.appContext.config.globalProperties.$producttype.trim() !== 'Eigenes Bild  XXL / 3' && this.instance.appContext.config.globalProperties.$producttype.trim() !== 'Eigenes Bild XXL / 5') {
      //   setTimeout(() => {
      //     this.automatischesZuschneiden();
      //   }, "300");
      // }

      if (!this.option["Größe"]) {
        return '30 30';
      }
      this.imgSize = document.querySelector('.preview-area img.croppedImage');

      if(!this.imgSize) {
        return;
      }
      const sizes = this.option["Größe"].split("x");
      let ration;
      let instance = getCurrentInstance();

      if(instance && instance.appContext.config.globalProperties.$producttype == 'Quadratisch') {
        return 1;
      }
      if(this.instance.appContext.config.globalProperties.$orientation) {
        if(this.instance.appContext.config.globalProperties.$orientation === 'landscape') {
          ration = sizes[1].slice(0, -2) + '/' + sizes[0]
        } else {
          ration = sizes[0] + '/' + sizes[1].slice(0, -2)
        }
      } else {
        if (this.imgSize.naturalWidth > this.imgSize.naturalHeight) {
          this.instance.appContext.config.globalProperties.$orientation = 'landscape';
          ration = sizes[1].slice(0, -2) + '/' + sizes[0]
        } else {
          this.instance.appContext.config.globalProperties.$orientation = 'portrait';
          ration = sizes[0] + '/' + sizes[1].slice(0, -2)
        }
      }

      return ration;
    }

    ,
    dp: function () {
      return this.type == 8341420540169 ? true : false;
    }
  }
  ,
}

</script>
<template>
  <PreviewHeader/>
  <section class="preview-area" v-if="!editor" :class="{ produktbild: !this.$route.matched[0]?.props.default.wand, mnz: (!this.dp ||this.tabActive === 'Eigenes Bild  XXL / 3' || this.tabActive === 'Eigenes Bild XXL / 5' ), maxHeight: this.tabActive ===  'Quadratisch' || this.rationCropper() < 1  }">

<!--    <template-->
<!--        v-if="instance.appContext.config.globalProperties.$producttype && (instance.appContext.config.globalProperties.$producttype.trim() == 'Eigenes Bild  XXL / 3' || instance.appContext.config.globalProperties.$producttype.trim() == 'Eigenes Bild XXL / 5')">-->
<!--      <div class="canvasBox">-->
<!--        <canvas id="canvas" @click="getCutImg()"></canvas>-->
<!--        <canvas id="canvas2" @click="getCutImg()"></canvas>-->
<!--        <canvas id="canvas3" @click="getCutImg()"></canvas>-->
<!--        <canvas id="canvas4" @click="getCutImg()"></canvas>-->
<!--        <canvas id="canvas5" @click="getCutImg()"></canvas>-->
<!--      </div>-->
<!--    </template>-->
<!--    <template v-else>-->
      <img
          v-if="cropImg"
          :src="cropImg"
          class="croppedImage"
          :class="{ dp : this.dp }"
          alt="Cropped Image" :style="{ aspectRatio: ration, width: cropImgWidth(), height: cropImgHeight()}"
      />
      <img class="rahmen" v-if="!this.$route.matched[0]?.props.default.wand && this.dp &&  this.tabActive !== 'Eigenes Bild  XXL / 3' && this.tabActive!== 'Eigenes Bild XXL / 5'"
           :src="'https://picmondo.de/projekte/generator/dist/assets/mask_2000/' + this.watchRahmen + '.png'" :style="{ width: rahmenImgWidth, height: rahmenImgHeight}">
<!--    </template>-->
  </section>
  <div class="editor" :class="{ open: editor}">

    <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :aspect-ratio="rationCropper()"
        :initialAspectRatio="rationCropper()"
        :view-Mode="1"
        style="height: 80%; margin-top:10%;"
    >
    </vue-cropper>
    <div class="editorOption">
      <a
          href="#"
          role="button"
        @click.prevent="zoom(-0.2)"
      >
        <img src="https://picmondo.de/projekte/generator/dist/assets/img/zoom_out_icon.svg"/>
        {{ t('zoomOut') }}
      </a>
      <a
          href="#"
          role="button"
          @click.prevent="zoom(0.2)"
      >
        <img src="https://picmondo.de/projekte/generator/dist/assets/img/zoom_in_icon.svg"/>
        {{ t('zoomIn') }}
      </a>
      <a
          href="#"
          role="button"
          @click.prevent="rotate(90)"
      >
        <img src="https://picmondo.de/projekte/generator/dist/assets/img/drehen_icon_white.svg">
        {{ t('rotate') }}
      </a>
      <a
          ref="flipX"
          href="#"
          role="button"
          @click.prevent="flipX"
      >
        <img src="https://picmondo.de/projekte/generator/dist/assets/img/spiegeln_icon_white.svg"/>
        {{ t('flip') }}
      </a>
      <a
          href="#"
          role="button"
          @click.prevent="stretch"
      >
        <svg viewBox="0 0 32 32" style="fill: #fff;" xmlns="http://www.w3.org/2000/svg"><g id="pin-number"><path d="m21.44 10.56a1.5 1.5 0 0 0 2.12 0l5.44-5.46v4.4a1.5 1.5 0 0 0 3 0v-8a1.5 1.5 0 0 0 -1.5-1.5h-8a1.5 1.5 0 0 0 0 3h4.35l-5.41 5.44a1.49 1.49 0 0 0 0 2.12z"/><path d="m1.5 11a1.5 1.5 0 0 0 1.5-1.5v-4.25l5.28 5.31a1.53 1.53 0 0 0 1.07.44 1.51 1.51 0 0 0 1.06-2.56l-5.41-5.44h4.5a1.5 1.5 0 0 0 0-3h-8a1.5 1.5 0 0 0 -1.5 1.5v8a1.5 1.5 0 0 0 1.5 1.5z"/><path d="m21.44 23.71 5.26 5.29h-4.2a1.5 1.5 0 0 0 0 3h8a1.5 1.5 0 0 0 1.5-1.5v-8a1.5 1.5 0 0 0 -3 0v4.56l-5.44-5.46a1.5 1.5 0 1 0 -2.12 2.11z"/><path d="m1.5 32h8a1.5 1.5 0 0 0 0-3h-4.35l5.26-5.29a1.5 1.5 0 1 0 -2.13-2.11l-5.28 5.3v-4.4a1.5 1.5 0 0 0 -3 0v8a1.5 1.5 0 0 0 1.5 1.5z"/></g></svg>
        {{ t('fitBox') }}
      </a>
    </div>
    <div class="editorAction">
      <a
          href="#"
          role="button"
          @click.prevent="handleEditorHide($event)"
      >
        {{ t('cancel') }}
      </a>
      <a
          href="#"
          role="button"
          @click.prevent="cropImage"
      >
        {{ t('apply') }}
      </a>
    </div>
  </div>
  <div class="buttons">
    <span class="btnUploadBack" @:click="reloadPage()">
     <img src="https://picmondo.de/projekte/generator/dist/assets/img/reload.png">  {{ t('restart') }}
    </span>
    <span class="btnEditor" :class="{ wandbild: this.$route.matched[0]?.props.default.wand}" v-if="!editor"
            v-on:click="handleButtonClick($event)">
      <img src="https://picmondo.de/projekte/generator/dist/assets/img/editIcon.svg"> {{ t('editImage') }}
    </span>
      <span class="btnVorschau" v-if="this.dp" @click="instance.appContext.config.globalProperties.vorschau = true">
      <RouterLink to="/vorschau">{{ t('previewLower') }}</RouterLink>
    </span>
  </div>



  <img class="bottom" :class="{ mnz: !this.dp }" style="width: 740pt"
       src="https://picmondo.de/projekte/generator/dist/assets/img/Sofa.png"/>

</template>

<style>
.preview-area {
  width: 100%;
  display: flex;
  justify-content: center;
  /*max-height: 70vh;*/
  max-width: 100%;
  min-height: 20%;
  align-items: center;

}
.preview-area.maxHeight {
  max-height: 70svh;
}
.wandbildMain .preview-area{
  margin-top: auto;
}

.preview-area:not(.produktbild) img {
  box-shadow: 0 0 5px 1px #616060;
}

.croppedImage.dp {
  position: absolute;
}

.wandbildMain .croppedImage {
  max-height: 100%;
  width: auto;
  position: static;
}
.editor {
  position: absolute;
  top: -2rem;
  left: -2rem;
  width: 100vw;
  background: #000;
  right: 0;
  bottom: -2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 100;
  margin-bottom: env(safe-area-inset-bottom);
  padding-bottom: 135px;
  visibility: hidden;
}

.editor.open {
  visibility: visible;
}

.editorOption {
  display: flex;
  justify-content: space-between;
  width: 700px;
  margin-top: 30px;
}

.editorOption a {
  display: flex;
  flex-direction: column;
  color: #fff;
  align-items: center;
  gap: 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}

.editorOption a img, .editorOption a svg{
  max-width: 30px;
}

.editorAction {
  display: flex;
  margin-top: 25px;
  justify-content: space-between;
}

.editorAction a {
  color: #fff;
  margin: 0 15px;
  background: rgb(255, 125, 176);
  background: linear-gradient(147deg, rgba(255, 125, 176, 1) 20%, rgba(255, 221, 90, 1) 100%);
  padding: 15px 100px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 18px;
}

.editorAction a:first-child {
  position: relative;
  background: #000;
}

.editorAction a:first-child:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  margin: -2px;
  border-radius: inherit;
  background: rgb(255, 125, 176);
  background: linear-gradient(147deg, rgba(255, 125, 176, 1) 20%, rgba(255, 221, 90, 1) 100%);
}

.bildbox {
  mmax-width: 50%;
  max-height: 40%;
}

.produktbild {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  /*max-height: 70vh;*/
  max-width: 70%;
}
.produktbild.mnz{
  width: 72%;
  height: 100%;
  max-height: 80vh;
}
.produktbild.mnz img {
  max-height: 70vh;
}

.produktbild img {
  max-width: 100%;
  max-height: 100%;
}

@media (prefers-color-scheme: dark) {
  html {
    color: #fff;
    background: #111;
  }

  .pintura-editor {
    --color-background: 10, 10, 10;
    --color-foreground: 255, 255, 255;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);
  }
}

.btnEditor, .btnUploadBack {
  position: absolute;
  bottom: 7%;
  background: #ffff;
  color: #001761;
  padding: 3pt 15pt;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  z-index: 10;
  font-size: 25px;
}

.btnEditor img {
  width: 25px;
  display: inline-block;
  margin-bottom: -2px;
}

.btnUploadBack img {
  width: 12px;
  display: inline-block;
  margin-bottom: -2px;
  margin-right: 3px;
}

@media (max-width: 720px) {
  .produktbild.mnz img {
    max-height: 100%;
  }

  .preview-area.maxHeight {
    max-height: 55svh
  }
  section.preview-area.produktbild.mnz.maxHeight {
    max-height: 45vh;
  }
  .editor {
    top: 0;
    left: -20px;
    height: 100svh;
    padding-bottom: 150px;
  }
  .preview-area:not(.produktbild) img {
    box-shadow: 0 0 3px 1px #616060;
  }
  section {
    height:100%;
  }
  section.navBar {
    max-height: 100%;
    justify-content: end;
    overflow: hidden;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .editorAction {
    flex-direction: column;
    gap: 25px;
  }
}
@media (max-width: 560px) {
.editorOption {
    width: 90%;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }
.editor {
  left: 0;
}
.editorOption a {
    font-size: 9.3pt;
}
.editorOption a img,.editorOption a svg {
  max-width: 20px;
}
.editorAction {
  flex-direction: row;
}
.editorAction a {
  padding: 10px 35px;
  font-size: 9.3pt;
}
}
</style>
